import { combineReducers } from 'redux'

import arquivosPlanosAnuaisContratacoes from './arquivosPlanosAnuaisContratacoes'

export default combineReducers({ arquivosPlanosAnuaisContratacoes })
